<template>
  <div class="container">
    <div class="section">
      <img
        class="img"
        src="https://s21.lgstatic.com/growth/activity/20220607/1654584482041.png"
      />
    </div>

    <div class="ceiling-view" v-if="ceilingType">
      <div class="ceiling-tab" :class="{ 'ceiling-fixed': ceilingType }">
        <van-tabs v-model="activeTab" :swipe-threshold="4" @click="tabChange">
          <van-tab
            v-for="(item, index) in tabList"
            :key="index"
            :title="item.stage"
          >
          </van-tab>
        </van-tabs>
        <div class="box"></div>
      </div>
    </div>

    <div class="section">
      <img
        class="img"
        src="https://s21.lgstatic.com/growth/activity/20220607/1654584525773.png"
      />
    </div>
    <div class="section" id="section_0">
      <img
        class="img"
        src="https://s21.lgstatic.com/growth/activity/20220607/1654584588406.png"
      />
    </div>
    <div class="section-main">
      <div class="s-main">
        <van-tabs v-model="active">
          <van-tab
            v-for="(item, index) in stageList"
            :key="index"
            :title="item.stage"
            class="tb"
          >
            <div class="t-title">
              {{ item.title }}
            </div>
            <img
              class="t-icon"
              src="https://s21.lgstatic.com/growth/activity/20210419/1618820076232.png"
            />
            <div class="target">
              <div class="title">
                <!-- <div class="target-link"></div> -->
                <div class="text-title">学习目标</div>
                <div
                  v-if="item.details.length > 0"
                  class="btn"
                  @click="getTags(item)"
                ></div>
              </div>
              <div class="content">
                <div
                  v-for="(val, ind) in item.phaseTargetList"
                  :key="ind"
                  class="content-list"
                >
                  <div class="icon"></div>
                  <div class="text">{{ val }}</div>
                </div>
              </div>
              <div class="title title1">
                <!-- <div class="target-link"></div> -->
                <div class="text-title">关键技术点</div>
              </div>
              <div class="content">
                <div
                  v-for="(val, ind) in item.skillsList"
                  :key="ind"
                  class="content-list"
                >
                  <div class="icon"></div>
                  <div class="text">{{ val }}</div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>

        <div class="tips-tab">
          * 具体课程内容以实际课程安排和进度为准
        </div>
      </div>
      <button class="stage-more" @click="JumpFn('领取完整课程安排')">
        <img class="botton_img" :src="imgObj.btn2" />
        <div class="tips-box">
          <img
            class="tips-img"
            src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
          />
        </div>
      </button>
    </div>
    <div class="section">
      <img
        class="img"
        src="https://s20.lgstatic.com/growth/activity/20220607/1654590474768.png"
      />
    </div>
    <div class="white" id="section_1"></div>
    <div class="section-view">
      <div :class="['img-tab', imgtabnum == 0 ? 'w100' : '']">
        <img
          class="img"
          :src="imgtabList[imgtabnum]"
          @click="imgclickFn(imgtabnum)"
        />
      </div>

      <button
        class="btn-img"
        :class="{ 'btn-img-2': imgtabnum == 1 }"
        @click="JumpFn('获取更多项目资料')"
      >
        <img class="botton_img" :src="imgObj.btn3" />
        <div class="tips-box">
          <img
            class="tips-img"
            src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
          />
        </div>
      </button>
    </div>
    <div class="section" id="section_2">
      <img
        class="img"
        src="https://s20.lgstatic.com/growth/activity/20221118/1668752479817.jpg"
      />
    </div>
    <!-- <div class="section" id="section_3">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220607/1654585438295.png">
        </div> -->
    <!-- <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220607/1654585495060.png">
            <div class="btn-pos" @click="JumpFn"></div>
        </div> -->
    <!-- <div class="section" id="section_4">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220607/1654585546237.png">
            <div class="current-container-wrap">
                <div class="swiper-container current-container" id="sw-section">
                    <div class="swiper-wrapper current-wraps">
                        <div
                            v-for="(value,inde) in swiperList"
                            :key="inde"
                            class="swiper-slide current-box"
                        >
                            <img class="company" :src="value.imgUrl"/>
                        </div>
                    </div>
                    <div class="swiper-pagination current-pagination" />
                </div>
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220607/1654585630762.png">
        </div>
        <div class="sw2" id="sw2">
            <div class="swiper-container current-container2" id="sw-section2">
                    <div class="swiper-wrapper current-wraps">
                        <div
                            v-for="(value,inde) in swiperList2"
                            :key="inde"
                            class="swiper-slide current-box"
                        >
                            <img class="company" :src="value"/>
                        </div>
                    </div>
                    <div class="swiper-pagination current-pagination" />
                </div>
        </div> -->
    <div class="section">
      <img
        class="img"
        src="https://s20.lgstatic.com/growth/activity/20221118/1668752382192.jpg"
      />
    </div>

    <div
      :class="{ 'modal-container': true, active: modalVisable }"
      v-if="modalVisable"
    >
      <div :class="{ layer: true, active: modalVisable }" />
      <div class="modal">
        <div
          :class="{
            'modal-content': true,
            active: modalVisable && modalType == 'text',
            'active-img': modalVisable && modalType != 'text'
          }"
        >
          <div class="close-container">
            <div class="close" @click="closeModal" />
          </div>
          <div v-if="modalType == 'text'">
            <div class="title">
              {{ moadlData.title }}
              <div class="sub-title">
                {{ moadlData.stage }}
              </div>
            </div>
            <div class="content">
              <div v-for="(val, inde) in moadlData.details" :key="inde">
                <div class="content-title">
                  {{ val.t }}
                </div>
                <div
                  class="content-desi"
                  v-for="(i, its) in val.desc"
                  :key="its"
                >
                  {{ i }}
                </div>
              </div>
            </div>
          </div>
          <div v-else class="content-img">
            <img :src="current" />
          </div>
        </div>
      </div>
    </div>

    <button class="footer" @click="JumpFn('名额有限立即抢占')">
      <div class="box10-right img pay-btn-wrapper">
        <div class="pay-btn">
          好课速享 马上抢占
        </div>
      </div>
      <img
        class="H5activityIcon"
        v-if="activity.isShow"
        :src="activity.H5icon"
      />
      <div class="img-box">
        <img
          class="img-btns"
          src="https://s21.lgstatic.com/growth/activity/20210831/1630410757988.png"
        />
      </div>
      <FooterPoup :id="17" :isDcsj="false" />
    </button>

    <RetainModal
      :visible="retainModalVisible"
      @removeHash="removeHash"
      pageId="1pxi"
    />
  </div>
</template>

<script>
import { handleJumpUrl } from "../../../uitl/getParam.js";
import List from "./data.js";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import RetainModal from "../../../components/RetainModal/index.vue";
import { postIsBuyCourse } from "../../../service/api";
import {
  getEduAppVersion,
  isBiggerThanSpecifiedVersion
} from "../../../uitl/getVersion";
import activity from "../../../common/activity";
import { Tab, Tabs } from "vant";
Vue.use(Tab);
Vue.use(Tabs);
// ios
// window.appBeforeGoBack = function () {
//     window.location.hash = 'showModal'
//     return 0
// }
// android
// if (isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.4')) {
//     window.appBeforeUnLoaded = function () {
//         window.location.hash = 'showModal'
//         return true
//     }
// }
export default {
  name: "JavaJaGouShiH5",
  components: {
    RetainModal
  },
  data() {
    return {
      activity, //活动图标
      List: List,
      imgObj: {},
      imgList: [],
      imgList1: [],
      tabList: [],
      stageList: [],
      swiperList: [],
      swiperList2: [],
      imgtabList: [],
      imgtabnum: 0,
      activeTab: 0,
      modalVisable: false,
      moadlData: {},
      current: "",
      modalType: "text",
      ceilingType: false, //吸顶tab
      retainModalVisible: false,
      canShowModal: false,
      addressIdsMap: {
        课程体系: "h1tub",
        实战项目: "i1tuc",
        就业服务: "j1tud",
        用户评价: "k1tue",
        领取完整课程安排: "m1tuf",
        获取更多项目资料: "n1tug",
        名额有限立即抢占: "p1tuh"
      }
    };
  },
  mounted() {
    // this.watchHashChange()
    let dataList = this.List.data;
    this.imgObj = dataList.h5.imgObj;
    this.imgList = dataList.h5.imgList;
    this.imgList1 = dataList.h5.imgList1;
    this.swiperList = dataList.h5.swiperList;
    this.swiperList2 = dataList.h5.swiperList2;
    this.imgtabList = dataList.h5.imgtabList;
    this.tabList = dataList.tabList;
    this.stageList = dataList.stageList;
    setTimeout(() => {
      // this.eduPlatTrack('WebView', { page_id: '1pxi'});
      this.platTrack("h5pv", {
        page_id: "1pxi"
      });
      this.renderSwipers();
    }, 500);
    window.addEventListener("scroll", this.scrollTopFn);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollTopFn);
  },
  methods: {
    scrollTopFn() {
      let scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.ceilingType = scroll > 450 ? true : false; //吸顶tab
      let arr = [
        "section_0",
        "section_1",
        "section_2"
        // "section_3",
        // "section_4",
      ];
      arr.forEach((item, index) => {
        if (document.getElementById(item).getBoundingClientRect().top < 100) {
          this.activeTab = index;
        }
      });
    },
    tabChange(val, title) {
      let arr = [
        "#section_0",
        "#section_1",
        "#section_2"
        // "#section_3",
        // "#section_4",
      ];
      this.$el.querySelector(arr[val]).scrollIntoView(true);
      let scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      document.documentElement.scrollTop = scroll - 50;
      document.body.scrollTop = scroll - 50;
      // this.eduPlatTrack('WebButtonClick', {
      //     'page_id': '1pxi',
      //     'button_name': title
      // });
      this.platTrackClickFn(title);
    },

    imgclickFn(imgtabnum) {
      this.imgtabnum = imgtabnum === 1 ? 0 : 1;
    },
    watchHashChange() {
      const that = this;
      window.addEventListener("hashchange", function(e) {
        postIsBuyCourse().then(res => {
          if (res.state == 1) {
            if (res.content) {
              window.lgBridge &&
                window.lgBridge.request("close", {}, res => {});
            } else {
              that.canShowModal = !res.content;
              if (window.location.hash == "#showModal" && that.canShowModal) {
                that.retainModalVisible = true;
              }
            }
          }
        });
      });
    },
    removeHash() {
      this.retainModalVisible = false;
      this.canShowModal = false;
      window.location.hash = "";
    },
    JumpFn(str) {
      // this.eduPlatTrack('WebButtonClick', {
      //     'page_id': '1pxi',
      //     'button_name': '领取成长路线图'
      // });
      str && this.platTrackClickFn(str);
      setTimeout(() => {
        window.location.href = "https://t.lagou.com/DR99RXRcs=6B1";
      }, 200);
    },
    renderSwipers() {
      let that = this;
      let option = {
        speed: 300,
        autoplay: 3000,
        loop: true,
        autoplayDisableOnInteraction: false,
        slidesPerView: "auto",
        spaceBetween: 10,
        onClick(e) {
          that.getSlide(e.realIndex);
        }
      };
      const swiper1 = new Swiper(".current-container", option);
      let option2 = {
        speed: 300,
        autoplay: 3000,
        loop: true,
        autoplayDisableOnInteraction: false,
        slidesPerView: "auto",
        spaceBetween: 10
      };
      const swiper2 = new Swiper(".current-container2", option2);
    },
    getSlide(num) {
      let item = this.swiperList[num];
      this.modalType = "img";
      this.fixedBody();
      this.current = item.storyImg;
      this.modalVisable = true;
    },
    getTags(item) {
      this.modalType = "text";
      this.fixedBody();
      this.modalVisable = true;
      this.moadlData = item;
    },
    closeModal() {
      this.looseBody();
      this.modalVisable = false;
    },
    fixedBody() {
      this.selfTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      document.body.style.cssText +=
        "position:fixed;overflow: hidden;width:100%;height: auto;top: -" +
        this.selfTop +
        "px";
    },
    looseBody() {
      var body = document.body;
      body.style.overflow = "auto";
      body.style.height = "auto";
      body.style.position = "";
      document.body.scrollTop = document.documentElement.scrollTop = parseInt(
        this.selfTop
      );
    },
    platTrackClickFn(name) {
      this.platTrack("h5click", {
        page_id: "1pxi",
        address_id: this.addressIdsMap[name]
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  background: #f2f2fa;
  padding-bottom: 190px;
  .section {
    position: relative;
    width: 100%;
    .img {
      width: 100%;
      display: block;
    }
    .img-icon {
      width: 158px;
      height: 158px;
      position: absolute;
      top: 0;
      right: 0;
    }
    .btn-pos {
      position: absolute;
      width: 464px;
      height: 88px;
      left: 143px;
      bottom: 24px;
    }
    .btn-img1 {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translate(-50%);
      width: 464px;
      background-color: transparent;
      border: none;
      z-index: 9;
      overflow: hidden;
      .botton_img {
        width: 100%;
        display: block;
      }
    }
    .current-container-wrap {
      position: absolute;
      bottom: 40px;
      left: 30px;
      width: calc(100% - 56px);
      height: 332px;
      box-sizing: border-box;
      overflow: hidden;
    }
    .current-container {
      width: 100%;
      height: 332px;
      position: absolute;
      bottom: 0;
      left: 0;
      .current-wraps {
        width: 582px;
        position: absolute;
        padding-left: 10px;
        .current-box {
          width: 100% !important;
          margin-left: 20px;
          img {
            width: 100%;
          }
        }
      }
    }
  }
  .ceiling-view {
    width: 100%;
    // height: 94px;
    // margin: 0px 0 40px;

    .ceiling-tab {
      position: relative;
      width: 100%;
      height: 94px;
      background: #ffffff;
      box-shadow: 0px 6px 8px 0px rgba(71, 68, 85, 0.08);
      z-index: 33;
      // /deep/ .van-tabs__wrap--scrollable{
      // height: 94px;
      // }
      .box {
        position: absolute;
        top: 0;
        right: 0;
        width: 60px;
        height: 94px;
        background: linear-gradient(
          270deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0) 100%
        );
      }
      /deep/ .van-tabs__nav {
        position: relative;
      }
      // /deep/ .van-tabs__wrap {
      //     height: 94px;
      // }
      /deep/ .van-tab {
        position: relative;
        width: 200px;
        height: 94px;
        color: #32355c;
        font-size: 30px;
        font-weight: 400;
      }
      /deep/.van-tab--active {
        box-sizing: border-box;
        color: #32355c;
        font-weight: 400;
        &::before {
          content: "";
          width: 32px;
          height: 32px;
          background: url("https://s21.lgstatic.com/growth/activity/20210913/1631520740389.png")
            no-repeat center;
          background-size: 100% 100%;
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          transition-duration: 0.3s;
        }
        .van-tab__text {
          padding-left: 24px;
        }
      }
      /deep/ .van-tabs__line {
        // bottom: 40px;
        background: linear-gradient(141deg, #a954ff 0%, #684cff 100%);
        width: 160px;
        height: 6px;
      }
    }
    .ceiling-fixed {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 30;
    }
  }

  .section-main {
    position: relative;
    width: 100%;
    margin-bottom: 80px;
    .stage-more {
      position: absolute;
      bottom: -54px;
      left: 50%;
      transform: translate(-50%);
      width: 422px;
      background-color: transparent;
      border: none;
      z-index: 9;
      overflow: hidden;
      .botton_img {
        width: 100%;
        display: block;
      }
    }
    .s-main {
      position: relative;
      margin: 0 auto;
      width: 688px;
      background-color: #fff;
      z-index: 2;
      border-radius: 8px;
      padding-bottom: 150px;
      box-shadow: 0px 2px 15px 0px rgba(225, 225, 225, 0.73);
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      overflow: hidden;
      .tb {
        position: relative;
        width: 100%;
        background-color: #fff;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        overflow: hidden;
        .t-title {
          text-align: center;
          font-size: 32px;
          color: #6469a7;
          font-weight: 500;
          padding: 25px 0 10px;
        }
        .t-icon {
          width: 688px;
          display: block;
          height: 2px;
        }
        .target {
          color: #6469a7;
          font-size: 26px;
          margin-top: 35px;
          .title {
            position: relative;
            display: flex;
            height: 49px;
            align-items: center;
            font-weight: bold;
          }
          .title1 {
            margin-top: 38px;
          }
          .text-title {
            width: 166px;
            height: 46px;
            border-radius: 30px;
            background: linear-gradient(
              192deg,
              rgba(99, 137, 255, 0.1) 0%,
              rgba(108, 101, 255, 0.1) 100%
            );
            text-align: center;
            line-height: 46px;
            margin-left: 40px;
          }
          .text {
            flex: 1;
          }
          .btn {
            position: absolute;
            right: 0;
            top: 0;
            width: 151px;
            height: 49px;
            background: url("https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png")
              no-repeat;
            background-size: 100% 100%;
            margin-right: 40px;
          }
          .content {
            margin-top: 10px;
          }
          .content-list {
            display: flex;
            color: #595959;
            line-height: 48px;
            font-size: 24px;
            .icon {
              width: 8px;
              height: 8px;
              background: #565659;
              border-radius: 50%;
              margin-left: 46px;
              margin-top: 20px;
              margin-right: 8px;
            }
            .text {
              opacity: 0.7;
              flex: 1;
              width: 612px;
              padding-right: 14px;
            }
          }
          .content-list:last-child {
            .icon {
              background: #fff;
            }
          }
        }
      }
      .tips-tab {
        position: absolute;
        bottom: 80px;
        right: 40px;
        color: #666;
        font-size: 12px;
      }
    }
    /deep/ .van-tabs__wrap--scrollable {
      height: 106px;
    }
    /deep/ .van-tabs__nav {
      background: linear-gradient(141deg, #a954ff 0%, #684cff 100%);
      height: 106px;
    }
    /deep/ .van-tabs--line .van-tabs__wrap {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }
    /deep/ .van-tab {
      width: 200px;
      height: 106px;
      color: #fff;
      font-size: 28px;
      font-weight: 400;
    }
    /deep/ .van-tabs__line {
      bottom: 40px;
      background: #fff;
      width: 64px;
      height: 6px;
    }
  }
  .section-view {
    // height: 1000px;
    .img-tab {
      width: 688px;
      height: 992px;
      margin: 20px auto 40px;
      position: relative;
      &.w100 {
        width: 100%;
      }
      .img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .btn-img {
      display: block;
      margin: 0 auto 40px;
      width: 464px;
      background-color: transparent;
      border: none;
      position: relative;
      overflow: hidden;
      top: -44px;
      &-2 {
        top: -44px;
      }
      .botton_img {
        width: 100%;
        display: block;
      }
    }
  }
  .sw2 {
    position: relative;
    left: 28px;
    width: calc(100% - 28px);
    height: 674px;
    padding: 0 28px;
    box-sizing: border-box;
    img {
      width: 357px;
    }
    .current-container2 {
      width: 100%;
      height: 674px;
      position: absolute;
      bottom: 0;
      left: 0;
      .current-wraps {
        width: 357px;
        position: absolute;
        padding-left: 10px;
        .current-box {
          width: 357px !important;
          // margin-left: 20px;
          img {
            width: 100%;
          }
        }
      }
    }
  }

  .layer {
    position: fixed;
    z-index: 9;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
    display: none;
    &.active {
      display: block;
    }
  }
  .modal {
    position: fixed;
    bottom: 180px;
    z-index: 10;
    display: flex;
    justify-content: center;
    .modal-content {
      width: 750px;
      height: 0;
      opacity: 0;
      transition: height 0.3s linear;
      overflow-y: scroll;
      &.active {
        opacity: 1;
        height: 962px;
        overflow: hidden;
      }
      &.active-img {
        opacity: 1;
        height: 662px;
        overflow: hidden;
      }
      background: #fff;
      border-radius: 18px 18px 0 0;
      position: relative;
      margin-right: 45px;
      box-sizing: border-box;
    }
    .close {
      width: 42px;
      height: 42px;
      background: url("https://s21.lgstatic.com/growth/activity/20210402/1617356751440.png")
        no-repeat;
      background-size: 42px 42px;
      position: absolute;
      right: 30px;
      top: 30px;
      border-radius: 50%;
      z-index: 1;
    }
    .title {
      margin-top: 82px;
      width: 658px;
      font-size: 32px;
      line-height: 40px;
      margin-bottom: 41px;
      padding-left: 45px;
      font-weight: bold;
      &-dot {
        width: 5px;
        height: 5px;
        border-radius: 5px;
        background: #fa4000;
      }
      .sub-title {
        color: #c69c6d;
        font-size: 26px;
        margin-top: 8px;
      }
    }
    .content {
      height: 755px;
      overflow-y: scroll;
    }
    .content-title {
      margin-bottom: 20px;
      font-weight: bold;
      color: #191f34;
      position: relative;
      padding-left: 47px;
      font-size: 26px;
      line-height: 28px;
      padding-right: 30px;
      &:before {
        content: "";
        width: 8px;
        height: 8px;
        background: #c69c6d;
        border-radius: 8px;
        position: absolute;
        left: 25px;
        top: 11px;
      }
    }
    .content-desi {
      margin-bottom: 48px;
      color: #5e6476;
      font-size: 26px;
      padding-left: 48px;
      padding-right: 30px;
    }
    .content-img {
      width: 100%;
      height: 100%;
      overflow-y: scroll;
    }
    .content-img img {
      width: 100%;
      margin: 0px auto;
      display: block;
    }
  }

  .footer {
    position: fixed;
    background-color: transparent;
    border: none;
    bottom: -1px;
    z-index: 999;
    width: 100%;
    box-shadow: 0px -12px 12px 0px rgba(156, 157, 185, 0.22);

    .pay-btn-wrapper {
      box-sizing: border-box;
      width: 750px;
      height: 158px;
      background-color: #fff;
      padding-top: 26px;
      .pay-btn {
        width: 90%;
        margin: 0 auto;
        height: 87px;
        line-height: 87px;
        color: #fff;
        border-radius: 30px;
        background-image: linear-gradient(90deg,  #fe5686, #ff8d5f);
      }
    }

    .img {
      width: 100%;
      display: block;
    }
    .H5activityIcon {
      position: absolute;
      top: -50px;
      right: 42px;
      width: 209px;
    }
    .img-box {
      position: absolute;
      top: 10px;
      left: 0;
      width: 100%;
      height: 100px;
    }
    .img-btns {
      position: absolute;
      top: 0px;
      left: 0px;
      animation: left 2s infinite linear;
      width: 224px;
      height: 120px;
    }
  }
  .tips-box {
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    .tips-img {
      position: absolute;
      top: 0px;
      left: 0px;
      animation: left 2.2s infinite linear;
      display: block;
      height: 100%;
    }
  }
  .white {
    width: 100%;
    height: 10px;
    background-color: #f2f2fa;
  }

  @keyframes left {
    0% {
      left: -50%;
    }
    50% {
      left: 100%;
    }
    100% {
      left: 200%;
    }
  }
}
</style>
